export const allowedVideoTypes = ['video/mp4', 'video/quicktime'];

export const maxFileSizeMB = 100;
export const maxFileSizeBytes = 1024 * 1024 * maxFileSizeMB;

export const videoLengthLimitSec = 90;
